/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_our_stores = /** @type {(inputs: {}) => string} */ () => {
	return `Naše obchody`
};

const da_our_stores = /** @type {(inputs: {}) => string} */ () => {
	return `Vores butikker`
};

const de_our_stores = /** @type {(inputs: {}) => string} */ () => {
	return `Unsere Geschäfte`
};

const en_our_stores = /** @type {(inputs: {}) => string} */ () => {
	return `Our stores`
};

const es_our_stores = /** @type {(inputs: {}) => string} */ () => {
	return `Nuestras tiendas`
};

const fr_our_stores = /** @type {(inputs: {}) => string} */ () => {
	return `Nos boutiques`
};

const hu_our_stores = /** @type {(inputs: {}) => string} */ () => {
	return `Üzleteink`
};

const it_our_stores = /** @type {(inputs: {}) => string} */ () => {
	return `I nostri negozi`
};

const nl_our_stores = /** @type {(inputs: {}) => string} */ () => {
	return `Onze winkels`
};

const pl_our_stores = /** @type {(inputs: {}) => string} */ () => {
	return `Nasze sklepy`
};

const pt_our_stores = /** @type {(inputs: {}) => string} */ () => {
	return `Nossas lojas`
};

const sv_our_stores = /** @type {(inputs: {}) => string} */ () => {
	return `Våra butiker`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const our_stores = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.our_stores(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("our_stores", locale)
	if (locale === "cs") return cs_our_stores(inputs)
	if (locale === "da") return da_our_stores(inputs)
	if (locale === "de") return de_our_stores(inputs)
	if (locale === "en") return en_our_stores(inputs)
	if (locale === "es") return es_our_stores(inputs)
	if (locale === "fr") return fr_our_stores(inputs)
	if (locale === "hu") return hu_our_stores(inputs)
	if (locale === "it") return it_our_stores(inputs)
	if (locale === "nl") return nl_our_stores(inputs)
	if (locale === "pl") return pl_our_stores(inputs)
	if (locale === "pt") return pt_our_stores(inputs)
	return sv_our_stores(inputs)
};